import { ActivatedRoute, Router } from '@angular/router';
import {
  bellIcon,
  bookIcon,
  clipboardTextIcon,
  dollarIcon,
  folderIcon,
  gearsIcon,
  homeIcon,
  userIcon,
} from '@progress/kendo-svg-icons';
import { User } from '../../../core/models/user';
import { ExtendedDrawerItem, LayoutConfig } from '../../../core/components/app-layout/layout-config';
import { isCyflareAdmin } from '../../../core/shared/cyflare-admin';
import { environment } from '../../../../environments/environment';

export const adminLayoutConfig: LayoutConfig = {
  menuItemsFactory: (user: User): ExtendedDrawerItem[] => {
    const items: ExtendedDrawerItem[] = [
      {
        text: 'Dashboard',
        svgIcon: homeIcon,
        path: '/admin/dashboard',
      },
      {
        text: 'Organizations',
        svgIcon: bellIcon,
        path: '/admin/organizations',
      },
      {
        text: 'Users',
        svgIcon: userIcon,
        path: '/admin/users',
      },
      {
        text: 'Advisories',
        svgIcon: clipboardTextIcon,
        path: '/admin/advisories',
      },
      {
        text: 'Detections Manager',
        svgIcon: gearsIcon,
        path: '/admin/manager',
      },
      {
        text: 'System Log',
        svgIcon: bookIcon,
        path: '/admin/syslog',
      },
      {
        text: 'ONE Roadmap',
        svgIcon: bookIcon,
        path: '/admin/roadmap',
      },
    ];

    // Billing is internal-admin only (matches the backend IsBillingAdmin gate).
    if (user?.groups?.includes('admin')) {
      items.push(
        {
          text: 'Product Catalog',
          svgIcon: dollarIcon,
          path: '/admin/billing/products',
        },
        {
          text: 'Dimension Links',
          svgIcon: dollarIcon,
          path: '/admin/billing/dimension-links',
        }
      );
    }

    // CASI is internal-staff only (same gate as the CASI side tab); the page's documents feed CASI's answers.
    if (environment.casiEnabled && isCyflareAdmin(user)) {
      items.push({
        text: 'CASI Knowledge',
        svgIcon: folderIcon,
        path: '/admin/casi-knowledge',
      });
    }

    return items;
  },

  footer: {
    showVipSupport: false,
    showResources: false,
    showNotifications: true,
    showSettings: false,
    showUserAvatar: true,
  },

  userMenuItemsFactory: (_user: User) => [{ text: 'Logout', icon: 'log-out' }],

  onOrgChange: (event: any, router: Router, _route: ActivatedRoute) => {
    const queryParams: { organizationId: number; account_type?: number } = {
      organizationId: event.id,
    };
    if (event.account_type != null) {
      queryParams.account_type = event.account_type;
    }
    router.navigate(['/customer/customer-dashboard'], { queryParams });
  },

  workspace: 'admin',
  settingsRoute: null,

  resourceLinks: [],

  scripts: {
    injectZoho: false,
    removeChatWidget: true,
  },
};
